export const generateColor = (inputString: string) => {
    const saltedString = `${inputString}x7f3d2a5`;
    let hash = 0;

    for (let i = 0; i < saltedString.length; i++) {
        hash = (hash << 5) - hash + saltedString.charCodeAt(i);
        hash |= 0;
    }

    const hue = (Math.abs(hash) % 120) * 3; // 0-359
    const saturation = 50 + (Math.abs(hash) % 30); // 50-79%
    const lightness = 45 + (Math.abs(hash) % 25); // 45-69%

    return hslToHex(hue, saturation, lightness);
};

const hslToHex = (h: number, s: number, _l: number) => {
    const l = _l / 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n: number) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};
